/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductionDeviceApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  saveProductionData(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDeviceDetails',
      Payload
    );
  }

  saveProductionDataUsingExcel(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDeviceDetailsUsingExcel',
      Payload
    );
  }

  addProductionDevice(Payload): Observable<any> {
    return this.http.post(
      this.APIService + 'device/saveDeviceDetails',
      Payload
    );
  }

  //fetch dispatch device
  getProductionDeviceList(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'device/getAllDeviceDetailsList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&selectedDeviceModelId=&selectedCustomerId='
    );
  }

  //fetch dispatch by id
  getProductionDeviceById(uid): Observable<any> {
    return this.http.get(
      this.APIService + 'device/getDeviceDetailsByUid?uid=' + uid
    );
  }

  updateProductionDeviceData(payload): Observable<any> {
    return this.http.put(
      this.APIService + 'device/updateDeviceDetails',
      payload
    );
  }

  deleteProductionData(uid, userId): Observable<any> {
    return this.http.delete(
      `${this.APIService}device/deleteDeviceDetailsByUid?uid=${uid}&userId=${userId}`
    );
  }
}
